module.exports = __webpack_public_path__ + "img/footballAssociation.73f129c6.png";